import axios from "axios";

/* =========================================================
ENVIRONMENT URL
========================================================= */

const BASE_URL =

  process.env.NODE_ENV === "development"

    /* LOCAL BACKEND */

    ? "http://localhost:3000/api"

    /* LIVE BACKEND */

    : "https://backend.sacmtb.com/api";

// Temporary upload tracing. Set REACT_APP_UPLOAD_DEBUG=false after verification.
const UPLOAD_DEBUG =
  process.env.REACT_APP_UPLOAD_DEBUG !== "false";

/* =========================================================
AXIOS INSTANCE
========================================================= */

const API = axios.create({

  baseURL: BASE_URL,

  timeout: 15000,
});

/* =========================================================
REQUEST INTERCEPTOR
========================================================= */

API.interceptors.request.use(

  (config) => {

    try {

      const isFormData =
        typeof FormData !== "undefined" &&
        config.data instanceof FormData;

      /*
       * Never set multipart Content-Type manually. Axios/the browser must add
       * the boundary. A JSON default makes Axios serialize FormData as JSON.
       */
      if (isFormData) {

        if (typeof config.headers.delete === "function") {
          config.headers.delete("Content-Type");
        } else {
          delete config.headers["Content-Type"];
        }
      }

      /* ADMIN */

      const adminData =
        JSON.parse(

          localStorage.getItem(
            "admin"
          ) || "{}"
        );

      /* USER */

      const userData =
        JSON.parse(

          localStorage.getItem(
            "user"
          ) || "{}"
        );

      /* TOKEN */

      const token =

        adminData?.token ||

        userData?.token ||

        localStorage.getItem(
          "token"
        );

      /* AUTH */

      if (token) {

        config.headers.Authorization =

          `Bearer ${token}`;
      }

      /* DEBUG */

      if (
        UPLOAD_DEBUG &&
        config.url?.includes("/upload")
      ) {

        const headers =
          typeof config.headers.toJSON === "function"
            ? config.headers.toJSON()
            : { ...config.headers };

        if (headers.Authorization) {
          headers.Authorization = "Bearer [redacted]";
        }

        console.log("[UPLOAD DEBUG] Axios request", {
          url: `${config.baseURL}${config.url}`,
          method: config.method?.toUpperCase(),
          baseURL: config.baseURL,
          timeout: config.timeout,
          headers,
          authorizationHeaderPresent: Boolean(headers.Authorization),
          totalFiles: isFormData
            ? Array.from(config.data.entries()).filter(
                ([field]) => field === "images"
              ).length
            : 0,
          payloadType: isFormData ? "FormData" : typeof config.data,
          browserWillSetMultipartBoundary: isFormData,
        });
      }

    } catch (err) {

      console.warn(

        "⚠️ Token parse error:",

        err
      );
    }

    return config;
  },

  (error) => {

    return Promise.reject(
      error
    );
  }
);

/* =========================================================
RESPONSE INTERCEPTOR
========================================================= */

API.interceptors.response.use(

  (response) => response,

  (error) => {

    /* =====================================
    RESPONSE ERROR
    ===================================== */

    if (error.response) {

      const status =
        error.response.status;

      /* 401 */

      if (status === 401) {

        console.warn(
          "🔒 Unauthorized"
        );

        localStorage.removeItem(
          "user"
        );

        localStorage.removeItem(
          "admin"
        );

        localStorage.removeItem(
          "token"
        );

        /* AVOID ADMIN LOOP */

        if (

          !window.location.pathname
          .includes("/login")

        ) {

          window.location.href =
            "/login";
        }
      }

      /* 500 */

      if (status === 500) {

        console.error(

          "🔥 Server Error:",

          error.response.data
        );
      }

      /* 404 */

      if (status === 404) {

        console.error(
          "❌ API Route Not Found"
        );
      }
    }

    /* =====================================
    NO RESPONSE
    ===================================== */

    else if (error.request) {

      console.error(

        "🌐 Backend not reachable"
      );

      console.error(
        "Check backend server"
      );
    }

    /* =====================================
    OTHER
    ===================================== */

    else {

      console.error(

        "⚠️ Axios Error:",

        error.message
      );
    }

    return Promise.reject(
      error
    );
  }
);

export default API;
